module.exports = __webpack_public_path__ + "images/category_bulk_estimate_btn_454745d65d71932debaec30c930186c7.png";